import React from 'react'

const Footer = () => (
    <div className="site-footer">
        <h4 className="text-center">
            Nice Nux
        </h4>
        <p className="text-center"> Follow us..</p>
        <div className="footer-social-links">
            <ul className="social-links-list">
                <li>
                    <a 
                        href="https://www.facebook.com" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="facebook">
                        <i className="fab fa-facebook-f fa-2x" />
                    </a>
                </li>
            </ul>
        </div>
    </div>

)
export default Footer